import { SET_BOOKING_DATA } from '../actions/action';

const initialState = {
  bookingData: []
};

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BOOKING_DATA:
      return {
        ...state,
        bookingData: action.payload.bookingData
      };
    default:
      return state;
  }
};

export default bookingReducer;
